import React, { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from 'src/components';

type Props = {
  testID?: string;
  light?: boolean;
};

const EMAIL = 'contact@smartcolis.com';
export const ContactUs: React.FC<Props> = ({ light, testID = 'ContactUs' }) => {
  const { t } = useTranslation();
  const [showEmail, setShowEmail] = useState<boolean>(false);

  const showContact = useCallback(
    (e?: any) => {
      if (e && e.preventDefault) {
        e.preventDefault();
      }
      setShowEmail(true);
    },
    [setShowEmail],
  );

  const lightClasses = light ? ' bg-purple-500 text-lg' : 'bg-secondary text-xl';

  const component = light ? (
    <a className="text-gray-600 text-lg" href="" onClick={showContact}>
      {t('contact-us-cta')}
    </a>
  ) : (
    <Button label="contact-us-cta" extraClasses={`py-2 px-8 text-xl ${lightClasses}`} onClick={showContact} noBg />
  );

  return (
    <div data-testid={testID} className="text-center m-0-auto  md:my-4">
      {!showEmail ? (
        component
      ) : (
        <div>
          <a href={`mailto:${EMAIL}`} className="block text-xl md:text-2xl mt-1" target="__blank">
            {EMAIL}
          </a>
        </div>
      )}
    </div>
  );
};
